var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.7088C0.5 1.12186 0.948 0.645508 1.5 0.645508C2.052 0.645508 2.5 1.12186 2.5 1.7088C2.5 2.29574 2.052 2.77209 1.5 2.77209C0.948 2.77209 0.5 2.29574 0.5 1.7088ZM0.5 7.02525C0.5 6.43832 0.948 5.96196 1.5 5.96196C2.052 5.96196 2.5 6.43832 2.5 7.02525C2.5 7.61219 2.052 8.08854 1.5 8.08854C0.948 8.08854 0.5 7.61219 0.5 7.02525ZM1.5 11.2784C0.948 11.2784 0.5 11.7548 0.5 12.3417C0.5 12.9286 0.948 13.405 1.5 13.405C2.052 13.405 2.5 12.9286 2.5 12.3417C2.5 11.7548 2.052 11.2784 1.5 11.2784ZM5.435 5.96196H17.564C18.079 5.96196 18.5 6.40961 18.5 6.9572V7.0933C18.5 7.6409 18.079 8.08854 17.564 8.08854H5.435C4.92 8.08854 4.5 7.6409 4.5 7.0933V6.9572C4.5 6.40961 4.92 5.96196 5.435 5.96196ZM17.564 11.2784H5.435C4.92 11.2784 4.5 11.7261 4.5 12.2737V12.4098C4.5 12.9574 4.92 13.405 5.435 13.405H17.564C18.079 13.405 18.5 12.9574 18.5 12.4098V12.2737C18.5 11.7261 18.079 11.2784 17.564 11.2784ZM5.435 0.645508H17.564C18.079 0.645508 18.5 1.09315 18.5 1.64075V1.77685C18.5 2.32444 18.079 2.77209 17.564 2.77209H5.435C4.92 2.77209 4.5 2.32444 4.5 1.77685V1.64075C4.5 1.09315 4.92 0.645508 5.435 0.645508Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a419d8b6577bd0a16b332b89ab2424d1.svg";
export { ForwardRef as ReactComponent };